import { useState, useRef, useEffect, useContext } from 'react'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import Translate from '../i18n/Translate'
import { ItinerariesContext } from '../context/ItinerariesProvider'
import { I18nContext } from '../context/I18nProvider'
import { writeSearch } from '../helpers'

import { HiOutlineSearch } from 'react-icons/hi'

import Select, { components } from 'react-select'

import LupaSvg from './svg/LupaSvg'
import ShortArrow from './svg/ShortArrow'
import { SpinnerEllipsis } from './Spinners'

const DestinationSearch = () => {
    const { t } = useTranslation()
    const history = useHistory()

    const { itinerariesOptions, contextSelectedOptions } = useContext(ItinerariesContext)
    const { language } = useContext(I18nContext)

    const experienceRef = useRef(null)
    const destinationRef = useRef(null)
    const [selectedDestination, setSelectedDestination] = useState('')
    const [selectedExperience, setSelectedExperience] = useState('')
    const [destinationsOptions, setDestinationsOptions] = useState([])
    const [experiencesOptions, setExperiencesOptions] = useState([])

    //Accedo a los itinerarios de viajes del contexto (destinos y tipo de experiencia para este caso) y los cargo en los Selects
    useEffect(() => {
        if (itinerariesOptions.destinations.length !== 0 && itinerariesOptions.types_of_experiences.length !== 0) {
            const destinationsFormatted = itinerariesOptions.destinations.map((destination) => ({
                value: destination,
                label: destination,
            }))
            const experiencesFormatted = itinerariesOptions.types_of_experiences.map((experience) => ({
                value: experience,
                label: experience,
            }))
            setDestinationsOptions(destinationsFormatted)
            setExperiencesOptions(experiencesFormatted)
        }
    }, [itinerariesOptions])

    //Veo si hay opciones ya seleccionadas en el contexto y la cargo en el Select
    //Si no hay opciones seleccionada por las dudas reseteo las opciones seleccionadas por si se reseteo el contexto
    useEffect(() => {
        if (contextSelectedOptions.destination !== '' || contextSelectedOptions.type_of_experience !== '') {
            setSelectedDestination(contextSelectedOptions.destination)
            setSelectedExperience(contextSelectedOptions.type_of_experience)
        } else {
            setSelectedDestination('')
            setSelectedExperience('')
        }
    }, [contextSelectedOptions])

    const handleDestinationChange = (selectedOption) => setSelectedDestination(selectedOption.value)

    const handleExperienceChange = (selectedOption) => setSelectedExperience(selectedOption.value)

    const handleSubmit = (e) => {
        e.preventDefault()

        if (!selectedDestination && !selectedExperience) {
            //Faltan ambos datos entonces setea el foco al primer input

            destinationRef.current.select.focus()

            return
        } else {
            //Setea los datos al contexto y y la lista de itinerarios escucha cambios en el contexto

            //Si estamos en la HOME, entonces empujamos a la ruta de Itinerarios junto con el search
            if (history.location.pathname !== `/${language}${t('routes.itineraries')}`) {
                history.push({
                    pathname: `/${language}${t('routes.itineraries')}`,
                    search: writeSearch(selectedDestination, null, selectedExperience),
                })
            } else {
                //Si estamos en la ruta de Itinerarios, entonces agrego el search a la url
                history.replace({
                    pathname: `/${language}${t('routes.itineraries')}`,
                    search: writeSearch(selectedDestination, null, selectedExperience),
                })
            }
        }
    }

    // Para cambiar el svg del indicador del select
    const IndicatorsContainer = (props) => (
        <components.DropdownIndicator {...props}>
            <ShortArrow width={20} height={20} />
        </components.DropdownIndicator>
    )

    const LoadingMessage = (props) => (
        <components.LoadingMessage {...props}>
            <SpinnerEllipsis />
        </components.LoadingMessage>
    )

    return (
        <form className="destination-search" onSubmit={handleSubmit}>
            <div className="destination-search__selects">
                <Select
                    options={destinationsOptions}
                    value={selectedDestination ? { value: selectedDestination, label: selectedDestination } : null}
                    isSearchable={false}
                    isLoading={destinationsOptions.length === 0}
                    onChange={handleDestinationChange}
                    components={{ IndicatorsContainer, LoadingMessage }}
                    className="destination-select"
                    classNamePrefix="destination-select"
                    placeholder={t('global_components.destination_search.destination_placeholder')}
                    ref={destinationRef}
                    hideSelectedOptions
                />
                <Select
                    options={experiencesOptions}
                    value={selectedExperience ? { value: selectedExperience, label: selectedExperience } : null}
                    isSearchable={false}
                    isLoading={experiencesOptions.length === 0}
                    onChange={handleExperienceChange}
                    components={{ IndicatorsContainer, LoadingMessage }}
                    className="destination-select"
                    classNamePrefix="destination-select"
                    placeholder={t('global_components.destination_search.experience_placeholder')}
                    ref={experienceRef}
                    hideSelectedOptions
                />
            </div>
            <button className="destination-search__button" type="submit">
                <HiOutlineSearch size="1.5em" />
                <Translate langkey="global_components.destination_search.search_button" />
            </button>
        </form>
    )
}

export default DestinationSearch
